import React from "react";
import Search from "./search.js";
import { Link } from "gatsby";

const Header = ({ menuStateUpdate, className }) => {
  return (
    <header className={ className }>
      {
        (className === "homepage")
        ? (<div>
          <h1>Cloud Provider Icons</h1>
          <p>Discover and get all the latest icons from cloud services providers available in high quality</p>
        </div>)
        : (<></>)
      }
      <Search />
      <Link to="/" title="Discover & download icons from cloud providers">
        Cloud Icons
      </Link>
    </header>
  );
};

export default Header;
